import { TOGGLE_TORCH_ERROR_POPUP } from "./displayTorchErrorPopupReducer"

export const toggleTorchErrorPopup = (obj) => ({
    type: TOGGLE_TORCH_ERROR_POPUP,
    payload: obj
})